import Service from "../../AuthService";
const ImportSheet = {
    getImportSheet(page) {
        return Service.get("/sheet-import?page="+page);
    },
    showImportSheet(id) {
        return Service.get("/sheet-import/" + id);
    },
    updateImportSheet(id, data) {
        return Service.put("/sheet-import/" + id, data);
    },
    createImportSheet(data) {
        return Service.post("/sheet-import", data);
    },
    deleteImportSheet(id) {
        return Service.delete("/sheet-import/" + id);
    },
    searchImportSheet(page,code, date) {
        return Service.post(
            "/search-sheet-import?page="+page+"&code=" + code + "&date=" + date
        );
    }
};
export default ImportSheet;
